"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6162],{

/***/ 86162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ multi_products_pricing_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./segments/desktop/pricing/product-pricing-config.js
var product_pricing_config = __webpack_require__(69535);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/index.js + 4 modules
var prices_and_features_cards_pricing = __webpack_require__(16834);
// EXTERNAL MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/index.js + 2 modules
var features_table_pricing = __webpack_require__(77552);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/pricing/icons/product-icon.js + 9 modules
var product_icon = __webpack_require__(62168);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-constants.js
var tooltip_constants = __webpack_require__(24984);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-component.js + 1 modules
var tooltip_component = __webpack_require__(31590);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/multi-products-pricing/components/product-switcher.scss.js



var StyledProductSwitcher = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12xydaw0"
})("z-index:", z_index/* TOP_LAYER */.nA, ";margin-top:0px;margin-bottom:42px;display:flex;align-items:center;justify-content:center;width:100%;position:relative;.product-item{width:98px;height:150px;display:flex;flex-direction:column;margin-right:22px;margin-left:14px;.product-button{display:flex;flex:1;flex-direction:column;align-items:center;background-color:transparent;.icon-container{display:flex;align-items:flex-end;flex:1;.product-icon{display:flex;border-radius:12px;width:64px;height:64px;justify-content:center;align-items:center;transition:transform 0.1s;background-color:var(--switcher-color);&.is-selected-product{width:86px;height:86px;svg{width:62px;height:62px;}}}}.icon-container:hover{transition-timing-function:ease-in;transition:transform 0.6s cubic-bezier(0.16,1,0.3,1);transform:scale3d(1.05,1.05,1);&.is-selected-product{transition:none;transform:none;}}.product-label{padding-top:16px;color:", colors/* default.asphalt */.Z.asphalt, ";height:30%;font-size:16px;&.is-selected-product{font-weight:600;color:", colors/* default.mud */.Z.mud, ";}}svg{width:42px;height:42px;}}.tooltip{border-radius:4px;opacity:0;display:none;z-index:", z_index/* TOP_LAYER */.nA, ";top:100%;left:100%;transform:translate(-50%);margin-top:8px;.floating-tooltip{white-space:normal;padding:16px;width:272px;line-height:20px;}}.tooltip:after{visibility:visible;opacity:1;z-index:", z_index/* TOP_LAYER */.nA, ";bottom:100%;rotate:180deg;left:38%;transform:translate(-100%);}}.product-item:hover{.tooltip{display:block;opacity:1;}}button{border:none;}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/multi-products-pricing/components/product-switcher.js










var ProductSwitcher = function(param) {
    var onProductChange = param.onProductChange, selectedProduct = param.selectedProduct, config = param.config, translate = param.translate;
    var ref = (0,react.useState)(false), hideTooltip = ref[0], setHideTooltip = ref[1];
    var products = (0,react.useMemo)(function() {
        var ans = [];
        Object.entries(config).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (value.showInSwitcher) {
                ans.push({
                    id: key,
                    label: value.switcherLabel,
                    color: value.switcherIconColor,
                    iconName: "".concat(key, "White"),
                    order: value.orderInSwitcher,
                    tooltipLabelKey: value.switcherTooltipLabelKey
                });
            }
        });
        ans.sort(function(a, b) {
            return a.order - b.order;
        });
        return ans;
    }, [
        config
    ]);
    var onMouseEnter = function(productIdHovered) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PRODUCT_SWITCHER_TOOLTIP_SHOWN, {
            info1: selectedProduct,
            info2: productIdHovered,
            productKind: selectedProduct
        });
    };
    var onMouseLeave = function(productIdHovered) {
        setHideTooltip(false);
        tackOnTooltipHidden(productIdHovered);
    };
    var tackOnTooltipHidden = function(productIdHovered) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PRODUCT_SWITCHER_TOOLTIP_HIDDEN, {
            info1: selectedProduct,
            info2: productIdHovered,
            productKind: selectedProduct
        });
    };
    var onProductSwitch = function(productId) {
        if (productId !== selectedProduct) {
            setHideTooltip(true);
            tackOnTooltipHidden(productId);
        }
        onProductChange(productId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductSwitcher, {
        className: "switcher-container",
        children: products.map(function(product) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("product-item", {
                    "is-selected-product": selectedProduct === product.id
                }),
                onMouseEnter: function() {
                    return onMouseEnter(product.id);
                },
                onMouseLeave: function() {
                    return onMouseLeave(product.id);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    style: {
                        "--switcher-color": product.color
                    },
                    type: "button",
                    className: "product-button",
                    onClick: function() {
                        onProductSwitch(product.id);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("icon-container", {
                                "is-selected-product": selectedProduct === product.id
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("product-icon", {
                                    "is-selected-product": selectedProduct === product.id
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_icon/* ProductIcon */.w, {
                                    product: product.iconName
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("product-label", {
                                "is-selected-product": selectedProduct === product.id
                            }),
                            children: [
                                product.label,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tooltip",
                                    children: !hideTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_component/* default */.Z, {
                                        theme: tooltip_constants.DARK_THEME,
                                        className: "floating-tooltip",
                                        children: translate(product.tooltipLabelKey)
                                    })
                                })
                            ]
                        })
                    ]
                }, product.id)
            });
        })
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/multi-products-pricing/multi-products-pricing-component.scss.js

var StyledMultiProductsPricingComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1vk7m3w0"
})("margin:auto;.product-switcher{margin-bottom:390px;}.signup-form{.ladda-button-component{.signup-button,.cta-button{background-color:var(--primary-color);letter-spacing:0.4px;max-width:none;width:100%;border:none;padding:16px 24px;font-size:16px;font-weight:400;}}}.signup-form:hover{.signup-button:hover,.cta-button:hover{background-color:var(--secondary-color);}}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/multi-products-pricing/multi-products-pricing-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var MultiProductsPricingComponent = function(props) {
    var pricesAndFeaturesCardsPricing = props.pricesAndFeaturesCardsPricing, translate = props.translate;
    var _productName = pricesAndFeaturesCardsPricing.productName, productName = _productName === void 0 ? undefined : _productName, _isHomepagePricing = pricesAndFeaturesCardsPricing.isHomepagePricing, isHomepagePricing = _isHomepagePricing === void 0 ? false : _isHomepagePricing, _isApplyMaxDiffFeatures = pricesAndFeaturesCardsPricing.isApplyMaxDiffFeatures, isApplyMaxDiffFeatures = _isApplyMaxDiffFeatures === void 0 ? false : _isApplyMaxDiffFeatures, _defaultSeatsIndex = pricesAndFeaturesCardsPricing.defaultSeatsIndex, defaultSeatsIndex = _defaultSeatsIndex === void 0 ? 0 : _defaultSeatsIndex;
    var ref = (0,react.useState)(productName), selectedProductName = ref[0], setSelectedProductName = ref[1];
    var selectedProductColors = (0,react.useMemo)(function() {
        var _selectedProductName = product_pricing_config/* default */.Z[selectedProductName], primaryColor = _selectedProductName.primaryColor, secondaryColor = _selectedProductName.secondaryColor;
        return {
            primaryColor: primaryColor,
            secondaryColor: secondaryColor
        };
    }, [
        selectedProductName
    ]);
    var onProductChange = (0,react.useCallback)(function(newProductName) {
        if (newProductName === selectedProductName) return;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PRODUCT_SWITCHER_CLICKED, {
            info1: selectedProductName,
            info2: newProductName,
            productKind: selectedProductName
        });
        setSelectedProductName(newProductName);
    }, [
        selectedProductName
    ]);
    var getSelectedProductId = function() {
        var productId = product_pricing_config/* default */.Z[selectedProductName].productId;
        return productId;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMultiProductsPricingComponent, {
        className: "multi-products-pricing-component",
        style: {
            "--primary-color": selectedProductColors.primaryColor,
            "--secondary-color": selectedProductColors.secondaryColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSwitcher, {
                onProductChange: onProductChange,
                selectedProduct: selectedProductName,
                config: product_pricing_config/* default */.Z,
                translate: translate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                className: "signup-form",
                ctaText: translate("signup.cta"),
                buttonColor: selectedProductColors.primaryColor,
                buttonSize: "xs",
                useCtaText: true,
                withButtonArrow: true,
                signupProductId: getSelectedProductId(),
                extraData: {
                    productKind: selectedProductName,
                    cta_name: "main_cta"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(prices_and_features_cards_pricing/* default.PricesAndFeaturesCardsPricingComponent */.Z.PricesAndFeaturesCardsPricingComponent, _object_spread_props(_object_spread({}, props), {
                productName: selectedProductName,
                isHomepagePricing: isHomepagePricing,
                defaultSeatsIndex: defaultSeatsIndex,
                isApplyMaxDiffFeatures: isApplyMaxDiffFeatures
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(features_table_pricing/* default.FeaturesTablePricingComponent */.Z.FeaturesTablePricingComponent, _object_spread_props(_object_spread({}, props), {
                productName: selectedProductName,
                isHomepagePricing: isHomepagePricing,
                defaultSeatsIndex: defaultSeatsIndex,
                isApplyMaxDiffFeatures: isApplyMaxDiffFeatures
            }))
        ]
    });
};
/* harmony default export */ var multi_products_pricing_component = (MultiProductsPricingComponent);


/***/ })

}]);